var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncrease(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_59_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_59_3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_59_3",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_59_3",
    width: 64,
    height: 64,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAw5JREFUeJztmstO20AUhr8DeYDKAQkB7TOQvEnFtaWldMOKbitVamISKlG2CFXqrhI3tYCQuulb4DxDRdNFMWJfnNNNoiYmiew4Do4z38p2xuPz/z5zPDMKGAwGg8FgMBhGE2k+yZXceYR9AJRNx86eP0hUA2Ss5UzYA6aAqfpx6hnznU93OE4tfgNGjpE3IPPQAXRjbvv6nai8BR6FuO0KlQ3Htn4EaZzYDMht/ZkWlQ+EEw8wi+jnoI0Ta0BEHgdtmFgDnK3Jqoq+B27jfE6ia0ClMLED7LT7ba7kLopwTEQNic2AbvRLPAyhAfmSu9xG/F2v/Q2VAbltd0GFQ1rFe6qy3mufQ2NAbttdQDnhvvhXFds66rXfoTCgk3hB1qOIhyEwoJv4y6J1GLX/RBsQt3hIsAGDEA8DmgjlS9dPVWQPqCG1N05h8nvX9mV3SZUjX3weKi8vbeukw223/F83BJ49xp4BufLNioqcArPAE3TsPF92lzq1z5fdJaW9eKezeBD5CNSAWv04ELEakCvfrIAeAuNNlzMKR+1M6Fk84BSs3UzNm8nUvBmnYO0GjbF1U7TsakunxazQIwGmqy3f8EGNeT+x1IAOb74xXW08c1xEv+TL7l+AdmNekTWnaB3HEWODvhvQSbwoLwB8U9lMPeX9sXiKrFViFu9/aGTmSu4i6AGt4j1VWXds6ytAbtv1fKnuj8ETZD3uN9+gb0Www5i/N1d3CtkzhGe0X8HFPub99MWAoOIbOIXsmSrPaTXBQ/X1IMVDHwzIlW9WRO5V7ztRVrstVCp29lRUl4BfQBVl2bEnDqLGE5ZINSDImO/GpT1xAVxEiSEqPWdA2LRPKj0ZkBbx0IMBaRIPIQ1Im3gIUQTrf544wT/Dg1XHtr71P7TBEDwDhE+0EX9ZzA6teAg3BJpXiqkQD6EyoLYB/AZ+IrX5NIiHEDWgvo3VdStrGEnspuigGHkDum6JpZCqqG7W1yDA6GXAtIrsN1/wG3A1wGASQasBKhuk24SqqG4+dBAGg8FgMBgMhiTwD0iZVbnFPrOTAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease);
export default __webpack_public_path__ + "static/media/increase.277d21b776eabd659a20e92a68baf483.svg";
export { ForwardRef as ReactComponent };